module.exports = __webpack_public_path__ + "static/media/globe.e9a5dcce.svg";